"use client";
import { MapPin, Clock, Calendar, Edit, Pencil } from "lucide-react";
import StepMarker from "../StepMarker";
import { Button } from "../Button";

export default function Step5Summary({ formData, onBack, onDone, goToStep }) {
  // Icons for event needs
  const needIcons = {
    "Cake Making": "🎂",
    Decoration: "🎊",
    Catering: "🍽️",
    Photography: "📸",
    Music: "🎵"
  };
  const date = formData.date ? new Date(formData.date) : new Date("2024-11-13");
  const day = date.getDate(); // 1–31
  const month = date.toLocaleString("default", { month: "short" }); // e.g. "Nov"
  const year = date.getFullYear(); // e.g. 2024

  return (
    <div>
      <StepMarker currentStep={5} totalSteps={5} onBack={onBack} />

      <h2 className="text-xl font-bold mb-1">Final check, Good to go!</h2>
      <p className="text-gray-500 mb-6">Take a moment to review</p>

      {/* Event Details Card */}
      <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
        <h3 className="font-bold text-lg">
          {formData.eventName || "Our Gender Reveal Party"}
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Join us as we reveal the exciting news and celebrate with family and
          friends!
        </p>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between">
          <div className="space-y-1 mb-4 sm:mb-0">
            {/*
            <div className="flex items-center">
              <Clock size={16} className="text-gray-500 mr-2" />
              <span className="font-medium">11:00 AM</span>
            </div>
            */}
            <div className="flex items-center">
              <Calendar size={16} className="text-gray-500 mr-2" />
              <div>
                <span className="font-medium">
                  {day} {month}
                </span>
                <div className="text-xs text-gray-500">{year}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center mb-4 sm:mb-0">
            <MapPin size={16} className="text-gray-500 mr-2 flex-shrink-0" />
            <span className="text-sm text-gray-600">
              {formData.venue || "Cesar Chavez Avenue"}
            </span>
          </div>

          <button
            onClick={() => goToStep(2)}
            className="flex items-center justify-center px-4 py-2 border border-[#7B189F]/20 rounded-lg text-[#7B189F] hover:bg-[#7B189F]/5 transition-colors"
          >
            <Edit size={16} className="mr-2 text-[#7B189F]" />
            Edit Details
          </button>
        </div>
      </div>

      {/* Event Budget */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-xs font-medium text-gray-500 uppercase">
            Event Budget
          </h3>
          <button
            onClick={() => goToStep(2)}
            className="text-gray-400 hover:text-gray-600"
          >
            <Pencil size={16} />
          </button>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <div className="flex justify-between items-center">
            <div>
              <div className="text-xl font-bold">${formData.budget}</div>
              <div className="text-sm text-gray-500">Total Planned Budget</div>
            </div>
          </div>
        </div>
      </div>

      {/* Event Needs & Enquiries */}
      {formData.needs.length > 0 && (
        <div>
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-xs font-medium text-gray-500 uppercase">
              Event Needs & Enquiries
            </h3>
          </div>

          <div className="space-y-4">
            {formData.needs.map(need => (
              <div
                key={need}
                className="bg-white border border-gray-200 rounded-lg p-5"
              >
                <div className="flex justify-between items-center mb-3">
                  <div className="flex items-center">
                    <span className="text-xl mr-2">
                      {needIcons[need] || "📋"}
                    </span>
                    <span className="font-medium">{need}</span>
                  </div>
                  <button
                    onClick={() => goToStep(4)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <Pencil size={16} />
                  </button>
                </div>

                <div className="text-xs text-gray-500 mb-2">
                  Chosen Partners for Quotes & Enquiries
                </div>

                {/*
                {formData.vendors?.length > 0 ? (
                  <div className="space-y-3">
                    {formData.vendors.map(vendor => (
                      <div key={vendor} className="flex items-center">
                        <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                          <img
                            src={
                              need === "Cake Making"
                                ? "/events/golden-wheat-loaf.png"
                                : "/events/elegant-decor-logo.png"
                            }
                            alt={vendor}
                            className="w-6 h-6 rounded-full"
                          />
                        </div>
                        <span className="text-sm">{vendor}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-sm text-gray-500">
                    No vendors selected
                  </div>
                )}
                */}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button
          onClick={onDone}
          className="bg-[#7B189F] hover:bg-[#671485] text-white"
        >
          Done
        </Button>
      </div>
    </div>
  );
}
